import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DashboardService {
  isBackDropVisible = new BehaviorSubject<boolean>(false);

  constructor(public configService: ConfigService, public networkService: NetworkService) { }

  // Header Service
  // Get Year data for Year dropdown
  public getCropYear() {
    return this.networkService.getRequest(this.configService.getCropYearUrl());
  }
  // Get Company data for Company dropdown
  public getCompanyCode() {
    return this.networkService.getRequest(this.configService.getCompanyCodeUrl());
  }
  // Get Company data for Company dropdown
  public updateCurrentSession(cropYear: string, companyCode: string) {
    return this.networkService.getRequest(this.configService.updateCurrentSessionUrl() + '?cropYear=' + cropYear + '&companyCode=' + companyCode);
  }

  // Landing Page Service
  // Get Grower Order data
  public getGrowerOrder(dashboardFilter) {
    const queryString = '?cropYear=' + dashboardFilter.cropYear + '&shipToAccount=' + dashboardFilter.shipToAccount + '&gMk=' + dashboardFilter.gMk;
    return this.networkService.getRequest(this.configService.getGrowerOrderUrl() + queryString);
  }

  // Get Dealer Order data
  public getDealerOrder(dashboardFilter) {
    return this.networkService.getRequest(this.configService.geDealerOrderUrl() + '?cropYear=' + dashboardFilter.cropYear + '&shipToAccount=' + dashboardFilter.shipToAccount);
  }

  // Get Account detail data for Account dropdown
  public getAccountList() {
    return this.networkService.getRequest(this.configService.getAccountListUrl());
  }

  // Get Partner SSO Urls
  public getPartnerWebsite(dashboardFilter) {
    return this.networkService.getRequest(this.configService.getPartnerWebsiteUrl() + '?accountNo=' + dashboardFilter.shipToAccount);
  }

  public GetApiDistance() {
    return this.networkService.getRequest('https://maps.googleapis.com/maps/api/distancematrix/json?origins=Seattle&destinations=San+Francisco&key=AIzaSyCkUOdZ5y7hMm0yrcCQoCvLwzdM6M8s5qk');
  }
}
